module.exports = __webpack_public_path__ + "img/BCA.ff73b3cd.svg";